import { Modal, Box, Typography, Button } from "@mui/material";
import warning from "../../../assets/warning.svg";
import CustomText, { textStyles } from "../../../components/CustomText";
import { useTheme } from "@mui/material/styles";
import CustomButton from "../../../components/CustomButton";
import { useTranslation } from "react-i18next";
const ProfileIncompleteModal = ({ open, onClose, onContinue }) => {
      const theme = useTheme();
      const { t } = useTranslation();
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 450,
          bgcolor: "white",
          p: 3,
          borderRadius: 2,
          textAlign: "center",
          boxShadow: "0px 4px 20px rgba(0,0,0,0.15)",
        }}
      >
         <img src={warning} style={{width:90,height:90}}/>

        <Typography     sx={{
                    ...textStyles,
                    fontSize: "24px",
                    fontWeight:500,
                      fontFamily: 'Poppins, sans-serif',
                    color: theme.palette.tertiary.main,
                    mb: 2,
                    mt:1, 
                    letterSpacing: "0px !important",
                  }}>
         {t("profileIncompleteModal.title")}
        </Typography>

        <Typography    sx={{
                    ...textStyles.body4,
                    color: theme.palette.text.primary,
                    mb: 3,
                  }}>
                 {t("profileIncompleteModal.description")}

        </Typography>
{/* 
        <Button
          variant="contained"
          fullWidth
          onClick={onContinue}
          sx={{ textTransform: "none" }}
        >
          Continue
        </Button> */}
        <CustomButton
          label= {t("profileIncompleteModal.continue")}
          fullWidth
          onClick={onContinue}
        />
      </Box>
    </Modal>
  );
};

export default ProfileIncompleteModal;
